import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminLayout } from '../features/admin'
import { canEnterAdmin, currentUserQuery } from '../features/admin/queries'

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQuery())
    if (!canEnterAdmin(me.role, location.pathname, Boolean(me.is_superadmin))) {
      if (me.role === 'billing') throw redirect({ to: '/admin/rates' })
      if (me.role === 'cover') throw redirect({ to: '/admin/contractors' })
      throw redirect({ to: '/' })
    }
  },
  component: AdminLayout,
})
